/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Listings_Filter_DraftInputs */

const en_seller_listings_filter_draft = /** @type {(inputs: Seller_Listings_Filter_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft`)
};

const es_seller_listings_filter_draft = /** @type {(inputs: Seller_Listings_Filter_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borradores`)
};

const fr_seller_listings_filter_draft = /** @type {(inputs: Seller_Listings_Filter_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brouillons`)
};

const de_seller_listings_filter_draft = /** @type {(inputs: Seller_Listings_Filter_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwurf`)
};

const ja_seller_listings_filter_draft = /** @type {(inputs: Seller_Listings_Filter_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下書き`)
};

const zh_seller_listings_filter_draft = /** @type {(inputs: Seller_Listings_Filter_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`草稿`)
};

const ar_seller_listings_filter_draft = /** @type {(inputs: Seller_Listings_Filter_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مسودة`)
};

const id_seller_listings_filter_draft = /** @type {(inputs: Seller_Listings_Filter_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draf`)
};

const it_seller_listings_filter_draft = /** @type {(inputs: Seller_Listings_Filter_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bozze`)
};

const ru_seller_listings_filter_draft = /** @type {(inputs: Seller_Listings_Filter_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Черновики`)
};

const pt_seller_listings_filter_draft = /** @type {(inputs: Seller_Listings_Filter_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rascunhos`)
};

const ko_seller_listings_filter_draft = /** @type {(inputs: Seller_Listings_Filter_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`임시저장`)
};

/**
* | output |
* | --- |
* | "Draft" |
*
* @param {Seller_Listings_Filter_DraftInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_listings_filter_draft = /** @type {((inputs?: Seller_Listings_Filter_DraftInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Listings_Filter_DraftInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_listings_filter_draft(inputs)
	if (locale === "es") return es_seller_listings_filter_draft(inputs)
	if (locale === "fr") return fr_seller_listings_filter_draft(inputs)
	if (locale === "de") return de_seller_listings_filter_draft(inputs)
	if (locale === "ja") return ja_seller_listings_filter_draft(inputs)
	if (locale === "zh") return zh_seller_listings_filter_draft(inputs)
	if (locale === "ar") return ar_seller_listings_filter_draft(inputs)
	if (locale === "id") return id_seller_listings_filter_draft(inputs)
	if (locale === "it") return it_seller_listings_filter_draft(inputs)
	if (locale === "ru") return ru_seller_listings_filter_draft(inputs)
	if (locale === "pt") return pt_seller_listings_filter_draft(inputs)
	return ko_seller_listings_filter_draft(inputs)
});